import React from "react";
import RichText from "@qlik/qlik/src/components/RichText";
import CounterCard from "@qlik/qlik/src/components/CardDeckContainer/Stats/CounterCard";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

/**
 * DeckCounterCards component
 * @param {Object} props - The props for the DeckCounterCards component
 * @param {Object} props.data - The data object
 */
const DeckCounterCards = ({ data }) => {
    // Destructuring the data object
    const {
        title,
        description,
        body,
        cardItems = [],
        numberOfColumns,
        additionalConfiguration,
        backgroundColor,
        customId,
    } = data ?? {};
    const bodyContent = body?.raw ?? null;
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-15");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    // Rendering the DeckCounterCards component
    return (
        <section className={`${sectionSpacingClassName} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="container">
                {title && (
                    <h2
                        className={`${sectionColorMapping.primaryTextColor} mb-5 md:text-center`}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                    />
                )}
                <div className="md:text-center text-base md:text-xl text-gray lg:text-2xl font-light leading-relaxed tracking-tight6 paragraph-text-inherit">
                    <p className={`${sectionColorMapping.secondaryTextColor} mb-8 md:mb-15`}>
                        {description?.description}
                    </p>
                    {bodyContent && <RichText data={data} className="flex flex-col gap-5" />}
                </div>
                <div
                    className={`mt-1.25 md:mt-5 grid grid-cols-1 gap-4.25 lg-gap-6 md:grid-cols-2 md:gap-7.5 ${
                        numberOfColumns === null ? "lg:grid-cols-4" : `lg:grid-cols-${numberOfColumns}`
                    }`}
                >
                    {cardItems?.map((card) => (
                        <div key={card?.id}>
                            <CounterCard card={card} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DeckCounterCards;
